import { useMemo } from 'react';
import type { SARadioMasterStatus } from '@/mocks/superAdminRadios';

interface RadioFiltersProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
  counts: Record<string, number>;
}

const filters = [
  { id: 'todas', label: 'Todas', icon: 'ri-radio-line' },
  { id: 'activas', label: 'Activas', icon: 'ri-play-circle-line' },
  { id: 'solicitudes', label: 'Solicitudes', icon: 'ri-mail-add-line' },
  { id: 'en_revision', label: 'En Revisión', icon: 'ri-search-eye-line' },
  { id: 'pendiente_contrato', label: 'Contrato Pendiente', icon: 'ri-file-text-line' },
  { id: 'pendiente_pago', label: 'Pago Pendiente', icon: 'ri-bank-card-line' },
  { id: 'suspendidas', label: 'Suspendidas', icon: 'ri-pause-circle-line' },
  { id: 'canceladas', label: 'Canceladas', icon: 'ri-close-circle-line' },
  { id: 'stream-activo', label: 'Stream Online', icon: 'ri-checkbox-circle-line' },
  { id: 'stream-caido', label: 'Stream Caído', icon: 'ri-signal-wifi-off-line' },
  { id: 'stream-inestable', label: 'Stream Inestable', icon: 'ri-error-warning-line' },
  { id: 'free', label: 'Free', icon: 'ri-vip-line' },
  { id: 'pro', label: 'Pro', icon: 'ri-star-fill' },
  { id: 'premium', label: 'Premium', icon: 'ri-vip-diamond-fill' },
];

export default function RadioFilters({ activeFilter, onFilterChange, counts }: RadioFiltersProps) {
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {filters.map((f) => {
        const isActive = activeFilter === f.id;
        const count = counts[f.id];
        return (
          <button
            key={f.id}
            onClick={() => onFilterChange(f.id)}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
              isActive
                ? 'bg-foreground-950 text-background-50'
                : 'text-foreground-500 bg-background-50 border border-background-200 hover:bg-background-100 hover:text-foreground-700'
            }`}
          >
            <i className={`${f.icon} text-[11px]`}></i>
            {f.label}
            {count !== undefined && (
              <span className={`text-[10px] font-bold ml-0.5 ${
                isActive ? 'text-background-50/70' : 'text-foreground-400'
              }`}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}